import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, ChangeRoleDialogueHandler } from '../types';
import ChangeUserRoleContext from './ChangeUserRoleContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type ChangeUserRoleDialogueProps = {
  handleDialogue: DialogueHandler<ChangeRoleDialogueHandler>;
};

type FC = FunctionComponent<ChangeUserRoleDialogueProps>;

const ChangeUserRoleDialogue: FC = ({ handleDialogue }: ChangeUserRoleDialogueProps) => {
  const { showChangeUserRoleSuccessAlert, showChangeUserRoleErrorAlert, ChangeUserRoleError } =
    useContext(ChangeUserRoleContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Users.ChangeUserRole.Dialog' });

  return useMemo(
    () => (
      <div>
        {/* Change role Error */}
        <ConfirmationDialogue
          isVisible={showChangeUserRoleErrorAlert}
          title={t('ChangeRoleError.title')}
          status="error"
          subTitle={`${ChangeUserRoleError}`}
          confirm={{
            label: t('ChangeRoleError.confirmButton'),
            action: () => handleDialogue({ type: 'change', state: 'fail' }),
          }}
        />
        {/* Change role Success */}
        <ConfirmationDialogue
          isVisible={showChangeUserRoleSuccessAlert}
          title={t('ChangeRoleSuccess.title')}
          status="success"
          subTitle={t('ChangeRoleSuccess.subTitle')}
          confirm={{
            label: t('ChangeRoleSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'change', state: 'success' }),
          }}
        />
      </div>
    ),
    [showChangeUserRoleSuccessAlert, showChangeUserRoleErrorAlert],
  );
};

export default ChangeUserRoleDialogue;
